/*
 * Copyright 2025 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package auth

import kotlinx.browser.localStorage

/**
 * Web implementation using localStorage for persistent user ID
 */
actual class UserIdManager {
    actual fun getUserId(): String {
        DemoUserOverride.userId?.let { return it }
        // Read from localStorage
        val stored = localStorage.getItem(USER_ID_KEY)
        if (stored != null && stored.isNotBlank()) {
            console.log("UserIdManager: Using localStorage userId:", stored)
            return stored
        }

        // Generate a temporary one if not found
        val newId = "user-web-${(kotlin.random.Random.nextInt(1000000))}"
        console.log("UserIdManager: Generated temporary userId:", newId)
        localStorage.setItem(USER_ID_KEY, newId)
        return newId
    }

    actual fun setUserId(userId: String) {
        localStorage.setItem(USER_ID_KEY, userId)
        console.log("UserIdManager: Set authenticated userId:", userId)
    }

    actual fun clearUserId() {
        localStorage.removeItem(USER_ID_KEY)
    }

    companion object {
        private const val USER_ID_KEY = "app_user_id"
    }
}
